@if (isLoading) {
  <!-- Heart Loader -->
  <div class="loader-overlay" role="status" aria-live="polite">
    <div class="heart-wrapper" aria-hidden="true">
      <svg class="heart-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          class="heart-shape"
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4 8.24 4 9.91 5 10.54 6.36
               11.17 5 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        />
        <polyline class="ekg" points="3 12 7 12 9 8 11 15 13 6 15 12 21 12" fill="none" />
      </svg>
    </div>
    <p class="loader-text mt-3 fw-semibold text-dark">Loading...</p>
  </div>
}

@if (!isLoading) {
  <div class="card border-0 shadow-sm appearance-settings-card">
    <div class="card-header bg-white">
      <h5 class="mb-1 fw-semibold">
        <i class="bi bi-palette-fill text-primary me-2"></i>
        Appearance Settings
      </h5>

      <small class="text-muted">
        Set the defaults that make the practice workspace feel ready from the moment you open it.
      </small>
    </div>

    <div class="card-body">
      <div class="alert alert-info d-flex align-items-start appearance-note">
        <i class="bi bi-info-circle-fill me-2 mt-1"></i>
        <div>
          These settings control the starting view of your scheduling workspace without changing any
          appointment data.
        </div>
      </div>

      <div class="row g-3 mb-4">
        <div class="col-md-4">
          <div class="card appearance-metric h-100 border-0">
            <div class="card-body">
              <div class="text-muted small mb-1">Calendar Start View</div>
              <div class="fs-4 fw-bold">{{ calendarViewLabel }}</div>
            </div>
          </div>
        </div>

        @if ('RECEPTION' | hasRole) {
          <div class="col-md-4">
            <div class="card appearance-metric h-100 border-0">
              <div class="card-body">
                <div class="text-muted small mb-1">Default Doctor</div>
                <div class="fs-4 fw-bold text-truncate">{{ selectedDoctorName }}</div>
              </div>
            </div>
          </div>
        }

        <div class="col-md-4">
          <div class="card appearance-metric h-100 border-0">
            <div class="card-body">
              <div class="text-muted small mb-1">Available Calendar Views</div>
              <div class="fs-4 fw-bold">3 Views</div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border-0 bg-light appearance-form-card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2">
            <div>
              <h6 class="mb-1 fw-semibold">Calendar Defaults</h6>
              <small class="text-muted">Choose the view and staff context to open first.</small>
            </div>

            <span class="badge text-bg-primary align-self-center"> Personalised workspace </span>
          </div>

          <div class="row g-3">
            <div class="col-lg-6">
              <label class="form-label fw-semibold"> Default Calendar View </label>

              <select class="form-select" [(ngModel)]="appearanceSettings.scheduleCalendarView">
                <option value="MONTH">Month View</option>

                <option value="WEEK">Week View</option>

                <option value="DAY">Day View</option>
              </select>

              <small class="text-muted d-block mt-2">
                This view will be displayed when opening the booking calendar.
              </small>
            </div>

            @if ('RECEPTION' | hasRole) {
              <div class="col-lg-6">
                <label class="form-label fw-semibold"> Default Doctor </label>

                <select class="form-select" [(ngModel)]="appearanceSettings.defaultDoctorId">
                  <option [ngValue]="null">All Doctors</option>

                  @for (doctor of clinicDoctors; track doctor.doctorId) {
                    <option [value]="doctor.doctorId">
                      Dr.
                      {{ doctor.firstName }}
                      {{ doctor.lastName }}
                    </option>
                  }
                </select>

                <small class="text-muted d-block mt-2">
                  Automatically select this doctor when opening appointments and schedules.
                </small>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <div
      class="card-footer bg-white d-flex justify-content-between align-items-center flex-wrap gap-2"
    >
      <small class="text-muted">
        Your saved defaults will be used the next time you open the calendar.
      </small>

      <button class="btn btn-primary" (click)="saveAppearanceSettings()">
        <i class="bi bi-floppy-fill me-2"></i>
        Save Settings
      </button>
    </div>
  </div>
}
